import React from "react";
import { usePageSeo } from "../../shared/seo";

const COPYRIGHT_HOLDER = "Fugu's Fresh";

const CopyrightPage = () => {
  usePageSeo("copyright");

  return (
    <section className="section py-40 py-sm-60">
      <div className="container container-lg">
        <div className="text-center mb-32 mb-sm-40">
          <h2 className="fw-bold text-main-700 mb-8">Copyright</h2>
          <p className="text-neutral-600 mb-0">Last Updated: August 2026</p>
        </div>

        <div className="mx-auto" style={{ maxWidth: "860px" }}>
          <div className="rounded-12 bg-white border border-main-100 p-24 p-sm-32" style={{ boxShadow: "0 2px 8px rgba(26, 107, 48, 0.05)" }}>
            <p className="text-neutral-700 mb-16">
              © {new Date().getFullYear()} {COPYRIGHT_HOLDER}. All rights
              reserved.
            </p>

            <p className="text-neutral-700 mb-16">
              All content included on this website, such as text, graphics,
              logos, button icons, images, audio clips, digital downloads, data
              compilations, and software, is the property of {COPYRIGHT_HOLDER}
              or its content suppliers and is protected by applicable copyright
              and other intellectual property laws.
            </p>

            <h5 className="fw-bold text-main-700 mb-8">1. Ownership of Rights</h5>
            <p className="text-neutral-700 mb-16">
              {COPYRIGHT_HOLDER} owns the exclusive rights to this website and
              its related applications ("the App"), including all design,
              code, graphics, and content. The year in which these rights were
              obtained is reflected in the copyright notice above together with
              the name of the rights holder.
            </p>

            <h5 className="fw-bold text-main-700 mb-8">2. Use of Content</h5>
            <p className="text-neutral-700 mb-16">
              You may view and print pages from this website for your own
              personal use solely in connection with shopping on Fugu's. You
              must not, without our prior written permission, reproduce,
              duplicate, copy, sell, resell, or exploit any portion of the
              website or the App.
            </p>

            <h5 className="fw-bold text-main-700 mb-8">3. Trademarks</h5>
            <p className="text-neutral-700 mb-16">
              "Fugu's", the Fugu's logo, and other marks used on this website
              are trademarks of {COPYRIGHT_HOLDER}. They may not be used in
              connection with any product or service that is not ours, in any
              manner that is likely to cause confusion among customers, or in
              any manner that disparages or discredits us.
            </p>

            <h5 className="fw-bold text-main-700 mb-8">4. Copyright Infringement</h5>
            <p className="text-neutral-700 mb-16">
              If you believe that any content on this website infringes upon
              your copyright, please notify us with a detailed description of
              the alleged infringement so that we can review and address it
              promptly.
            </p>

            <h5 className="fw-bold text-main-700 mb-8 mt-32">5. Contact Us</h5>
            <p className="text-neutral-700 mb-0">
              For any questions regarding this copyright notice, please contact
              us at{" "}
              <a href="mailto:fugusfresh@gmail.com" className="text-main-600 text-decoration-none">
                fugusfresh@gmail.com
              </a>{" "}
              or write to us at Ground Floor, Ward No. 16, Door No 446B, 446 C,
              FUGUS BUILDING, Elbo Road, Puthuvype, Ernakulam, Kerala - 682508.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CopyrightPage;